/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FitAndProperCheckViewModel } from './FitAndProperCheckViewModel';
import {
    FitAndProperCheckViewModelFromJSON,
    FitAndProperCheckViewModelFromJSONTyped,
    FitAndProperCheckViewModelToJSON,
} from './FitAndProperCheckViewModel';

/**
 * 
 * @export
 * @interface CommissionSplitViewModel
 */
export interface CommissionSplitViewModel {
    /**
     * 
     * @type {number}
     * @memberof CommissionSplitViewModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CommissionSplitViewModel
     */
    initials?: string;
    /**
     * 
     * @type {string}
     * @memberof CommissionSplitViewModel
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CommissionSplitViewModel
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof CommissionSplitViewModel
     */
    intermediaryCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommissionSplitViewModel
     */
    isAdvisingIntermediary?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommissionSplitViewModel
     */
    isServicingIntermediary?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommissionSplitViewModel
     */
    annualFeeSplitPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof CommissionSplitViewModel
     */
    lumpSumFeeSplitPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof CommissionSplitViewModel
     */
    recurringFeeSplitPercentage?: number;
    /**
     * 
     * @type {FitAndProperCheckViewModel}
     * @memberof CommissionSplitViewModel
     */
    fitAndProperStatus?: FitAndProperCheckViewModel;
    /**
     * 
     * @type {boolean}
     * @memberof CommissionSplitViewModel
     */
    isDefault?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommissionSplitViewModel
     */
    bankBrokerApplicationNumber?: number;
}

/**
 * Check if a given object implements the CommissionSplitViewModel interface.
 */
export function instanceOfCommissionSplitViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CommissionSplitViewModelFromJSON(json: any): CommissionSplitViewModel {
    return CommissionSplitViewModelFromJSONTyped(json, false);
}

export function CommissionSplitViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionSplitViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'initials': !exists(json, 'Initials') ? undefined : json['Initials'],
        'firstName': !exists(json, 'FirstName') ? undefined : json['FirstName'],
        'surname': !exists(json, 'Surname') ? undefined : json['Surname'],
        'intermediaryCode': !exists(json, 'IntermediaryCode') ? undefined : json['IntermediaryCode'],
        'isAdvisingIntermediary': !exists(json, 'IsAdvisingIntermediary') ? undefined : json['IsAdvisingIntermediary'],
        'isServicingIntermediary': !exists(json, 'IsServicingIntermediary') ? undefined : json['IsServicingIntermediary'],
        'annualFeeSplitPercentage': !exists(json, 'AnnualFeeSplitPercentage') ? undefined : json['AnnualFeeSplitPercentage'],
        'lumpSumFeeSplitPercentage': !exists(json, 'LumpSumFeeSplitPercentage') ? undefined : json['LumpSumFeeSplitPercentage'],
        'recurringFeeSplitPercentage': !exists(json, 'RecurringFeeSplitPercentage') ? undefined : json['RecurringFeeSplitPercentage'],
        'fitAndProperStatus': !exists(json, 'FitAndProperStatus') ? undefined : FitAndProperCheckViewModelFromJSON(json['FitAndProperStatus']),
        'isDefault': !exists(json, 'IsDefault') ? undefined : json['IsDefault'],
        'bankBrokerApplicationNumber': !exists(json, 'BankBrokerApplicationNumber') ? undefined : json['BankBrokerApplicationNumber'],
    };
}

export function CommissionSplitViewModelToJSON(value?: CommissionSplitViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Initials': value.initials,
        'FirstName': value.firstName,
        'Surname': value.surname,
        'IntermediaryCode': value.intermediaryCode,
        'IsAdvisingIntermediary': value.isAdvisingIntermediary,
        'IsServicingIntermediary': value.isServicingIntermediary,
        'AnnualFeeSplitPercentage': value.annualFeeSplitPercentage,
        'LumpSumFeeSplitPercentage': value.lumpSumFeeSplitPercentage,
        'RecurringFeeSplitPercentage': value.recurringFeeSplitPercentage,
        'FitAndProperStatus': FitAndProperCheckViewModelToJSON(value.fitAndProperStatus),
        'IsDefault': value.isDefault,
        'BankBrokerApplicationNumber': value.bankBrokerApplicationNumber,
    };
}

